import {UserModel} from '../modules/auth'

export const isAdmin = (user: UserModel | undefined): boolean => {
  if (user === undefined) return false
  return user.roles.includes('admin')
}
